<template>
  <div class="producto-envasado-card card shadow-sm mb-3" :class="{ 'anulado': envasado.anulado }">

    <!-- Header -->
    <div class="card-header d-flex justify-content-between align-items-center"
      :class="{ 'bg-secondary text-white': envasado.anulado, 'bg-purple text-white': !envasado.anulado }">
      <div class="d-flex align-items-center gap-2">
        <font-awesome-icon :icon="['fas', envasado.anulado ? 'ban' : 'box-open']" />
        <span>{{ envasado.anulado ? 'Envasado Anulado' : 'Producto Envasado' }}</span>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="badge bg-white text-dark">#{{ envasado.codigo }}</span>
        <button class="btn btn-sm btn-outline-light p-1" @click="copiarCodigo(envasado.codigo)" title="Copiar código">
          <font-awesome-icon :icon="['fas', 'copy']" />
        </button>
      </div>

      <div class="dropdown">
        <button class="btn btn-sm btn-outline-light dropdown-toggle" type="button" data-bs-toggle="dropdown">
          <font-awesome-icon :icon="['fas', 'ellipsis-v']" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" @click="$emit('editar', envasado)">
              <font-awesome-icon :icon="['fas', 'edit']" class="me-2" /> Editar
            </a>
          </li>
          <li>
            <a class="dropdown-item" @click="mostrarActualizarPrecio = !mostrarActualizarPrecio">
              <font-awesome-icon :icon="['fas', 'dollar-sign']" class="me-2" /> Actualizar Precio
            </a>
          </li>
          <li>
            <a class="dropdown-item" @click="verArbol = true">
              <font-awesome-icon :icon="['fas', 'sitemap']" class="me-2" /> Ver Trazabilidad
            </a>
          </li>
          <li>
            <a class="dropdown-item text-danger" @click="anularEnvasado">
              <font-awesome-icon :icon="['fas', 'times']" class="me-2" /> Anular
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mensaje flotante de copiado -->
    <div v-if="copiado" class="mensaje-copiado">
      Código copiado
    </div>

    <!-- Body -->
    <div class="card-body p-3">

      <!-- Tipo Producto -->
      <h5 class="mb-3 text-purple fw-semibold">{{ envasado.tipo_producto }}</h5>

      <!-- Producto Final (Origen) -->
      <div class="mb-2">
        <small class="text-muted">Origen:</small>
        <span class="badge bg-light-purple text-purple ms-2">{{ envasado.producto_final_bulk?.codigo || '-' }}</span>
        <button class="btn btn-sm  p-1" @click="copiarCodigo(envasado.producto_final_bulk.codigo)"
          title="Copiar código">
          <font-awesome-icon :icon="['fas', 'copy']" />
        </button>
      </div>

      <!-- Tipo Envase -->
      <div class="mb-2">
        <small class="text-muted">Envase:</small>
        <span class="badge bg-light-purple text-purple ms-2">{{ envasado.tipo_envase }}</span>
      </div>

      <!-- Stock Disponible en Peso -->
      <div class="mb-2">
        <small class="text-muted">Stock Disponible en Unidades:</small>
        <strong class="text-dark ms-2" style="font-size: 1.2rem; color: #ff0000;">{{ envasado.stock_disponible }} ({{
          envasado.cantidad_unidades * envasado.peso_por_unidad }} {{ envasado.unidad_medida_peso_envase }})</strong>
      </div>


      <!-- Cantidad Original -->
      <div class="mb-2">
        <small class="text-muted">Cantidad Original:</small>
        <strong class="text-dark ms-2">{{ envasado.cantidad_unidades }} x {{ envasado.peso_por_unidad }} {{
          envasado.unidad_medida_peso_envase }} = {{ envasado.cantidad_unidades * envasado.peso_por_unidad }} {{
            envasado.unidad_medida_peso_envase }}</strong>
      </div>



      <!-- Precio Unitario -->
      <div class="mb-2">
        <small class="text-muted">Precio Unitario:</small>
        <strong class="text-dark ms-2">{{ envasado.precio_unitario?.toFixed(2) }} {{ envasado.tipo_moneda }}</strong>
      </div>

      <!-- Ganancia total -->
      <div class="mb-2">
        <small class="text-muted">Ganancia Total:</small>
        <strong class="text-dark ms-2">{{ (envasado.precio_unitario * envasado.cantidad_unidades).toFixed(2) }} {{
          envasado.tipo_moneda }}</strong>
      </div>

      <!-- Detalles expandibles -->
      <div v-if="verDetalles" class="detalles mt-3 p-3 rounded bg-light border">
        <p><small class="text-muted">Fecha Envasado:</small> {{ formatoFecha(envasado.fecha_envasado) }}</p>
        <p><small class="text-muted">Fecha Vencimiento:</small> {{ formatoFecha(envasado.fecha_vencimiento) }}</p>
        <p><small class="text-muted">Observaciones:</small> {{ envasado.observaciones || '-' }}</p>
      </div>

      <button v-if="!envasado.anulado" class="btn btn-sm btn-link text-purple mt-3" @click="verDetalles = !verDetalles">
        <font-awesome-icon :icon="['fas', verDetalles ? 'chevron-up' : 'chevron-down']" class="me-1" />
        {{ verDetalles ? "Ocultar detalles" : "Ver detalles" }}
      </button>

      <!-- Actualizar Precio Expandible -->
      <div v-if="mostrarActualizarPrecio" class="actualizar-precio mt-3 p-3 rounded bg-light border">
        <ActualizarPrecioProductoEnvasado :envasado="envasado" @cancelar="mostrarActualizarPrecio = false"
          @precioActualizado="precioActualizado" />
      </div>
    </div>



    <!-- Modal de trazabilidad -->
    <div v-if="verArbol" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Trazabilidad - {{ envasado.producto_final_bulk?.codigo }}</h5>
            <button type="button" class="btn-close" @click="verArbol = false"></button>
          </div>
          <div class="modal-body p-0">
            <TrazabilidadBuscador :codigo-inicial="envasado.codigo" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="verArbol = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import axios from '@/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ActualizarPrecioProductoEnvasado from './ActualizarPrecioProductoEnvasado.vue';
import TrazabilidadBuscador from '@/components/Trazabilidad/TrazabilidadBuscador.vue';

export default {
  name: "ProductoFinalEnvasadoCard",
  components: { FontAwesomeIcon, ActualizarPrecioProductoEnvasado, TrazabilidadBuscador },
  props: {
    envasado: { type: Object, required: true }
  },
  data() {
    return {
      verDetalles: false,
      mostrarActualizarPrecio: false,
      copiado: false,
      verArbol: false
    };
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return "-";
      return new Date(fecha).toLocaleDateString();
    },
    copiarCodigo(codigo) {
      navigator.clipboard.writeText(codigo).then(() => {
        this.copiado = true;
        setTimeout(() => {
          this.copiado = false;
        }, 2000);
      }).catch(err => {
        console.error('Error al copiar el código: ', err);
      });
    },
    async anularEnvasado() {
      const cantidadDevolver = this.envasado.cantidad_unidades * this.envasado.peso_por_unidad;

      const confirmar = confirm(`¿Está seguro que desea anular este envasado?\n\nSe devolverán ${cantidadDevolver} ${this.envasado.unidad_medida_peso_envase} al Producto Final correspondiente.`);
      if (!confirmar) return;

      let motivo = "";
      while (!motivo) {
        motivo = prompt("Ingrese el motivo de anulación:");
        if (motivo === null) return;
        if (!motivo.trim()) alert("El motivo es obligatorio.");
      }

      try {
        await axios.put(`/api/producto_final_envasado_anular/${this.envasado.id}`, {
          club_id: this.envasado.club_id,
          motivo_anulacion: motivo
        });

        this.$emit('anulado', this.envasado);
        this.$toast?.success("Envasado anulado correctamente.");
        if (!this.$toast) alert("Envasado anulado correctamente.");

      } catch (error) {
        console.error("Error al anular:", error);
        alert("Error al anular el envasado.");
      }
    },
    precioActualizado(nuevoEnvasado) {
      this.$emit('precioActualizado', nuevoEnvasado);
      this.mostrarActualizarPrecio = false;
    }
  }
};
</script>

<style scoped>
.producto-envasado-card {
  border-radius: 0.75rem;
  overflow: hidden;
}

.card-header {
  font-weight: 600;
  font-size: 0.95rem;
}

.card-body h5 {
  color: #654EA3;
  /* violeta oscuro */
}

.bg-purple {
  background-color: #654EA3;
}

.text-purple {
  color: #654EA3;
}

.bg-light-purple {
  background-color: #ececf9;
}

.card-body p {
  margin-bottom: 0.4rem;
}

.card-footer button {
  width: 36px;
  height: 36px;
  padding: 0;
}

.anulado {
  opacity: 0.5;
}

.anulado .card-header {
  background-color: #6c757d !important;
}

.mensaje-copiado {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #654EA3;
  color: white;
  padding: 5px 10px;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  z-index: 10;
  opacity: 0.9;
  animation: fadeOut 1.5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 0.9;
  }

  80% {
    opacity: 0.9;
  }

  100% {
    opacity: 0;
  }
}
</style>
